/**
 * Support links (Phase 14, PRD SUP-04/05, §8.5). Everything here is PHI-free by construction: the
 * prefilled email carries the tenant ID and the app area only, never a patient name, MRN, URL
 * path with record IDs, or free text from the screen.
 */
import { TokenService } from '../services/auth/token.service';

export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'support@pelorahealth.com';
export const SECURITY_EMAIL = process.env.REACT_APP_SECURITY_EMAIL || 'security@pelorahealth.com';
export const HELP_CENTER_URL = process.env.REACT_APP_HELP_CENTER_URL || 'https://www.pelorahealth.com/help';

function tenantIdOrUnknown(): string {
  const id = TokenService.getTenantId();
  return id && /^[A-Za-z0-9_-]{1,64}$/.test(id) ? id : 'unknown';
}

/** mailto: for "Contact support" with the tenant ID; the user writes the question. */
export function supportMailto(area?: string): string {
  const subject = 'Pelora support request';
  const lines = [
    `Agency ID: ${tenantIdOrUnknown()}`,
    ...(area && /^[A-Za-z ]{1,40}$/.test(area) ? [`Area: ${area}`] : []),
    '',
    'Describe the problem. Please do not include patient names, dates of birth or other health information.',
  ];
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join('\n'))}`;
}

/** mailto: for "Report a security concern" (§8.5 incident intake). */
export function securityMailto(): string {
  const subject = 'Security concern';
  const body = [
    `Agency ID: ${tenantIdOrUnknown()}`,
    '',
    'What happened and when? Do not include patient information; we will contact you for details.',
  ].join('\n');
  return `mailto:${SECURITY_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
